import { createApi } from '../http/http-common';
import { AxiosResponse } from 'axios';
import {
  authHandler,
  validTokenHandler,
  invalidTokenHandler,
} from './interceptor-handlers/AuthHandler';
import { CustomerData } from '@/web-components/logo-upload/typings/common/CustomerData';

const customerDataAPI = createApi({
  BASE_URL: process.env.VUE_APP_CUSTOMERS_BASE_URL,
});
// Setup interceptors for the Customers API
customerDataAPI.interceptors.request.use(authHandler, function (error) {
  return Promise.reject(error);
});

customerDataAPI.interceptors.response.use(
  validTokenHandler,
  invalidTokenHandler
);

// customersAPI.interceptors.response.use(function (response) {
//   // Any status code that lie within the range of 2xx cause this function to trigger
//   return response;
// }, ErrorHandler);

export default {
  //#region Working with CustomerArtworks
  getCustomerId({
    externalCustomerId,
  }: {
    externalCustomerId: string;
  }): Promise<AxiosResponse<CustomerData>> {
    return customerDataAPI.get(`/customers/${externalCustomerId}`, {
      params: {},
    });
  },
};
